import { ChangeDetectorRef, Component, inject, Input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModule, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { HowToScoreArray, userScore } from '../../../utils/constants';
import { ICONS } from '../../../utils/svg-icons';
import { SafeHtmlPipe } from '../../validators/safe-html.pipe';
import { ScoreDetailsComponent } from '../scoring-details/scoring-details.component';

@Component({
  selector: 'app-score-popup',
  imports: [CommonModule, NgbModule, FormsModule, SafeHtmlPipe],
  templateUrl: './score-popup.component.html',
  styleUrl: './score-popup.component.scss',
})
export class ScorePopupComponent {
  isRejected = false;
  reasonSelected: any = 'Incomplete or low-quality content';
  options = userScore;
  value = 50;
  percent = 0;
  maxValue = 100;
  @Input() filtersList: any;
  isInitialized = false;
  breakPoints = [50, 60, 70, 80, 90, 100];
  private offcanvasService = inject(NgbOffcanvas);
  ICONS = ICONS;
  minFicorScore: any = 50;

  constructor(
    private cdr: ChangeDetectorRef,
    private _activeModal: NgbActiveModal,
  ) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.isInitialized = true;
      if (this.filtersList?.level?.ficorScore) {
        this.maxValue = this.filtersList?.level?.ficorScore;
        this.minFicorScore = this.filtersList?.level?.minFicorScore || 50;
        this.value = this.filtersList?.level?.minFicorScore || 50;
        const step = (this.maxValue - this.minFicorScore) / 5; // Divide into 4 equal parts
        this.breakPoints = Array.from({ length: 5 }, (_, i) => Math.round(this.minFicorScore + step * i)); // Generate break points
      }
      this.cdr.detectChanges(); // Trigger re-render
    }, 100);
  }
  onClose(): void {
    this._activeModal.close();
  }
  changeRange(event: any) {
    this.value = event.target.value;
    this.percent = ((this.value - this.minFicorScore) / (this.maxValue - this.minFicorScore)) * 100;
  }
  // Function to emit selected reason
  onSelectionChange(event: any) {
    this.reasonSelected = event.target.value;
    // this.reasonSelected.emit(this.reasonSelected); // Emit selected option
  }
  confirm() {
    let data: any = {
      score: this.value,
    };
    if (this.isRejected) {
      data['isRejected'] = true;
      data['rejectReason'] = this.reasonSelected;
    } else {
      data['isRejected'] = false;
    }
    this._activeModal.close(data);
  }
  onCheckboxChange(event: any) {
    this.isRejected = event.target.checked;
  }
  showScoring() {
    const offcanvasRef = this.offcanvasService.open(ScoreDetailsComponent, {
      position: 'end',
      backdrop: true,
      panelClass: 'scoreCanvas',
      backdropClass: 'scoreCanvasBackdrop',
    });

    offcanvasRef.componentInstance.HowToScoreArray = [...HowToScoreArray];
  }
}
